import ScrollWatcher from './ScrollWatcher';

export default class Header {
  constructor() {
    this.$header = $('.banner');

    this.scroll();
  }

  scroll() {
    new ScrollWatcher(
      () => {
        this.$header.removeClass('banner--slim');
      },
      () => {
        this.$header.addClass('banner--slim');
      },
      {
        onload: true,
      }
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Header.js